import { MutableState } from '../State';
import * as Fate from '../fate';
import { fatePermanentStatusEffects } from '../fate/fate.ruleset';
import { getCurrentEvolution } from '../pet/pet.getters';
import { setAttribute } from '../pet/pet.modifiers';
import features from '../ruleset/features';
import { puzzleCoinsIsPlayingTutorial } from './puzzlecoins.getters';

export function puzzleCoinsSetPetInitialState(
  state: MutableState,
  now: number,
): boolean {
  // This can happen only during the tutorial.
  if (!puzzleCoinsIsPlayingTutorial(state)) {
    return false;
  }

  const newPet = getCurrentEvolution(state);
  if (!newPet) {
    return false;
  }

  // Resolve all status effects.
  fatePermanentStatusEffects.forEach((effect) => {
    Fate.modifiers.resolveStatusEffect(state, effect, false, now);
  });

  // Reset pet stats.
  setAttribute(state, 'stomach', 39, now);
  setAttribute(state, 'love', 41, now);
  setAttribute(state, 'dirtiness', 0, now);
  setAttribute(state, 'toothAcidity', 0, now);
  setAttribute(state, 'urine', 0, now);

  // pet state updated
  return true;
}
